export default __webpack_public_path__ + "static/media/sd-tn-vertical.c92e33db.svg";